export const userBasicInfoPublicPages = `
  _id
  email
  type
  logo
  session
  companyName
  status
`;

export const userBasicInfoQuery = `_id
email
type
session
companyName
nationality
headquarters
shipsNumber
logo
description
staff
status
ports {
  name
  country
}
notifications {
  _id
  type
  offerId
  serviceRequestId
}
fees {
  nobundle
  bundle5
  bundle10
  bundle15
  bundle20
  bundle30
  bundle50
  bundle100
  bundle200
  yearly
}
remainingServices
subscriptionStatus
subscriptionRenewal
rating
ratingCount
isTroubleshootingEnabled
bundlesEnabled
hasPendingInvoices
departments
`;

export const companyBasicInfoQuery = `_id
type
status
companyName
nationality
headquarters
logo
shipsNumber
remainingServices
departments
`;

export const supplierBasicInfoQuery = `_id
status
type
companyName
nationality
staff
logo
description
terms
photos{
  label
  url
}
ports {
  name
  country
}
remainingServices
rating
ratingCount
isTroubleshootingEnabled
`;

export const serviceRequestQuery = `_id
userId
shipId
identificationInfo {
  shipName
  companyName
  shipsNumber
  nationality
  logo
  shipLength
  shipBreadth
  shipDwt
  shipClassification
  shipFlag
  brokerName
  brokerLogo
}
suppliers
equipments {
  title
  category
  subcategory
  maker
  type
  description
}
standardService{
  title
  matching
}
files
description
port {
  name
  country
}
eta
etd
agent {
  companyName
  personName
  mobilePhone
  officePhone
  email
}
agentAllInfo
travellingSuppliersAllowed
shareDetails
offers
duration
createdAt
status
billing {
  owningCompany
  address
  city
  postcode
  country
  vat
}
purchaseOrderNumber
ratingId
serviceReports
invoice
draft
uniqueId
erpServiceId
personOfContact
underwaterJobs
troubleshootingRequestId
troubleshootingRequestChat {
  senderName
  sender
  text
  time
}
cancelationReason
department
actualCost
`;

export const shipQuery = `_id
name
email
uniqueId
type
length
draught
breadth
dwt
yard
buildDate
imo
image
classification
equipments {
  _id
  title
  category
  subcategory
  description
  attachments
  maker
  type
}
billing {
  owningCompany
  address
  city
  postcode
  country
  vat
}
flag
subscriptionStatus
subscriptionRenewal
`;

export const troubleshootingOfferQuery = `
_id
userId
description
newSupplierMessage
newCompanyMessage
messages{
  senderName
  sender
  text
  time
}
identificationInfo{
  companyName
  nationality
  logo
}
`;

export const troubleshootingRequestQuery = `
_id
userId
shipId
serviceRequestId
identificationInfo {
  shipName
  companyName
  shipsNumber
  nationality
  logo
  shipClassification
  shipFlag
}
equipments {
  title
  category
  subcategory
  maker
  type
  description
}
description
files
shareDetails
offers {
  ${troubleshootingOfferQuery}
}
createdAt
status
ratingId
actions {
  type
  offerId
  userId
  time
}
uniqueId
personOfContact
`;

export const userTransactionsQuery = `
status
price
createdAt
type
`;

export const offerQuery = `
_id
serviceRequestId
userId
user {
  _id
  terms
  companyName
  rating
  ratingCount
  fees {
    nobundle
  }
  remainingServices
}
type
description
currency
identificationInfo {
  companyName
  nationality
  logo
  travelling
}
serviceCost
travellingCost
oldTotalCost
totalCost
spareParts {
  title
  type
  description
  price
}
paymentTerms
staff {
  type
  amount
  normal
  overtime
  double
  travelling
}
estimatedHours {
  type
  min
  max
}
rank
status
newSupplierMessage
newCompanyMessage
messages {
  sender
  text
  time
  senderName
}
underwater{
  propeller
  propellerPolishing
  hullInspection
  verticalSides
  flatBottom
  mobilizationDemobilization
  boatHire
  oldLumpSum
  lumpSum
}
extraCharges
extraChargesDescription
timeUnit
oldTotalCostConverted
totalCostConverted
currencyConverted
underwaterConverted {
  propeller
  propellerPolishing
  hullInspection
  verticalSides
  flatBottom
  mobilizationDemobilization
  boatHire
  oldLumpSum
  lumpSum
}
commission
cancelationReason
offerDocument
attendingEngineer {
  name
  email
  phone
}
priceChangesCounter
`;
